// Author Lin
// Date 2022-02-27 18:16:04

class SithMesMstKamList {
        constructor({
                id = null,
                projectWbs = '',
                indicateKey = '',
                categoryId = '',
                enNetwork = '',
                enNetworkCode = '',
                cid = '',
                enActivityId = '',
                enElementCode = '',
                enElementName = '',
                enElementType = '',
                spiridonActivityId = '',
                spiridonActivityName = '',
                batchUnit = '',
                material = '',
                quantity = '',
                engineerName = '',
                participateAssembly = '',
                scope = '',
                materialDirection = '',
                specialNotes = '',
                materialCn = '',
                materialType = '',
                ptoPts = '',
                procType = '',
                specialTech = '',
                ipt = '',
                materialGroup = '',
                purchaseGroup = '',
                pdt = '',
                grt = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.projectWbs = projectWbs;
            this.indicateKey = indicateKey;
            this.categoryId = categoryId;
            this.enNetwork = enNetwork;
            this.enNetworkCode = enNetworkCode;
            this.cid = cid;
            this.enActivityId = enActivityId;
            this.enElementCode = enElementCode;
            this.enElementName = enElementName;
            this.enElementType = enElementType;
            this.spiridonActivityId = spiridonActivityId;
            this.spiridonActivityName = spiridonActivityName;
            this.batchUnit = batchUnit;
            this.material = material;
            this.quantity = quantity;
            this.engineerName = engineerName;
            this.participateAssembly = participateAssembly;
            this.scope = scope;
            this.materialDirection = materialDirection;
            this.specialNotes = specialNotes;
            this.materialCn = materialCn;
            this.materialType = materialType;
            this.ptoPts = ptoPts;
            this.procType = procType;
            this.specialTech = specialTech;
            this.ipt = ipt;
            this.materialGroup = materialGroup;
            this.purchaseGroup = purchaseGroup;
            this.pdt = pdt;
            this.grt = grt;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new SithMesMstKamList();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.sith.mst.sithMesMstKamList.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'projectCode',
                label: 'label.sith.mst.sithMesMstKamList.grid.projectCode',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'projectName',
                label: 'label.sith.mst.sithMesMstKamList.grid.projectName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'projectWbs',
                label: 'label.sith.mst.sithMesMstKamList.grid.projectWbs',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'indicateKey',
                label: 'label.sith.mst.sithMesMstKamList.grid.indicateKey',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'categoryId',
                label: 'label.sith.mst.sithMesMstKamList.grid.categoryId',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'enNetwork',
                label: 'label.sith.mst.sithMesMstKamList.grid.enNetwork',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'enNetworkCode',
                label: 'label.sith.mst.sithMesMstKamList.grid.enNetworkCode',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'cid',
                label: 'label.sith.mst.sithMesMstKamList.grid.cid',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'enActivityId',
                label: 'label.sith.mst.sithMesMstKamList.grid.enActivityId',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'enElementCode',
                label: 'label.sith.mst.sithMesMstKamList.grid.enElementCode',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'enElementName',
                label: 'label.sith.mst.sithMesMstKamList.grid.enElementName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'enElementType',
                label: 'label.sith.mst.sithMesMstKamList.grid.enElementType',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'spiridonActivityId',
                label: 'label.sith.mst.sithMesMstKamList.grid.spiridonActivityId',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'spiridonActivityName',
                label: 'label.sith.mst.sithMesMstKamList.grid.spiridonActivityName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'batchUnit',
                label: 'label.sith.mst.sithMesMstKamList.grid.batchUnit',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'material',
                label: 'label.sith.mst.sithMesMstKamList.grid.material',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'quantity',
                label: 'label.sith.mst.sithMesMstKamList.grid.quantity',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'engineerName',
                label: 'label.sith.mst.sithMesMstKamList.grid.engineerName',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'participateAssembly',
                label: 'label.sith.mst.sithMesMstKamList.grid.participateAssembly',
                sortable: true,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'scope',
                label: 'label.sith.mst.sithMesMstKamList.grid.scope',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'SAG' },
                                    { value: '2', text: 'SITH' },
                                    { value: '3', text: 'MIXED' }
                    ]
                }
                },
                {
                key: 'materialDirection',
                label: 'label.sith.mst.sithMesMstKamList.grid.materialDirection',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'R' },
                                    { value: '2', text: '3rd' }
                    ]
                }
                },
                {
                key: 'specialNotes',
                label: 'label.sith.mst.sithMesMstKamList.grid.specialNotes',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'materialCn',
                label: 'label.sith.mst.sithMesMstKamList.grid.materialCn',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'materialType',
                label: 'label.sith.mst.sithMesMstKamList.grid.materialType',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'HALB' },
                                    { value: '2', text: 'ROH' }
                    ]
                }
                },
                {
                key: 'ptoPts',
                label: 'label.sith.mst.sithMesMstKamList.grid.ptoPts',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'PTO' },
                                    { value: '2', text: 'PTS' }
                    ]
                }
                },
                {
                key: 'procType',
                label: 'label.sith.mst.sithMesMstKamList.grid.procType',
                sortable: true,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                ,options: [
                        { value: '1', text: 'E' },
                                    { value: '2', text: 'F' }
                    ]
                }
                },
                {
                key: 'specialTech',
                label: 'label.sith.mst.sithMesMstKamList.grid.specialTech',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'ipt',
                label: 'label.sith.mst.sithMesMstKamList.grid.ipt',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'materialGroup',
                label: 'label.sith.mst.sithMesMstKamList.grid.materialGroup',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'purchaseGroup',
                label: 'label.sith.mst.sithMesMstKamList.grid.purchaseGroup',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'pdt',
                label: 'label.sith.mst.sithMesMstKamList.grid.pdt',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'grt',
                label: 'label.sith.mst.sithMesMstKamList.grid.grt',
                sortable: true,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstKamList.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            projectCodeFilter : '',
            projectNameFilter : '',
            projectWbsFilter : '',
            indicateKeyFilter : '',
            categoryIdFilter : '',
            enNetworkFilter : '',
            enNetworkCodeFilter : '',
            cidFilter : '',
            enActivityIdFilter : '',
            enElementCodeFilter : '',
            enElementNameFilter : '',
            enElementTypeFilter : '',
            spiridonActivityIdFilter : '',
            spiridonActivityNameFilter : '',
            batchUnitFilter : '',
            materialFilter : '',
            quantityFilter : '',
            engineerNameFilter : '',
            participateAssemblyFilter : '',
            scopeFilter : '',
            materialDirectionFilter : '',
            specialNotesFilter : '',
            materialCnFilter : '',
            materialTypeFilter : '',
            ptoPtsFilter : '',
            procTypeFilter : '',
            specialTechFilter : '',
            iptFilter : '',
            materialGroupFilter : '',
            purchaseGroupFilter : '',
            pdtFilter : '',
            grtFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'projectCodeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.projectCode',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'projectNameFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.projectName',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'projectWbsFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.projectWbs',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'indicateKeyFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.indicateKey',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'categoryIdFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.categoryId',
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enNetworkFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.enNetwork',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enNetworkCodeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.enNetworkCode',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'cidFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.cid',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enActivityIdFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.enActivityId',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enElementCodeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.enElementCode',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enElementNameFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.enElementName',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enElementTypeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.enElementType',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'spiridonActivityIdFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.spiridonActivityId',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'spiridonActivityNameFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.spiridonActivityName',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'batchUnitFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.batchUnit',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.material',
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'sithMesMstMaterial'
                    ,correspondingField: 'material'
                        }
                },
                {
                key: 'quantityFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.quantity',
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'engineerNameFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.engineerName',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'participateAssemblyFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.participateAssembly',
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'scopeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.scope',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: 'SAG' },
                        { value: '2', text: 'SITH' },
                        { value: '3', text: 'MIXED' }
                    ]
                }
                },
                {
                key: 'materialDirectionFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.materialDirection',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: 'R' },
                        { value: '2', text: '3rd' }
                    ]
                }
                },
                {
                key: 'specialNotesFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.specialNotes',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialCnFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.materialCn',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialTypeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.materialType',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: 'HALB' },
                        { value: '2', text: 'ROH' }
                    ]
                }
                },
                {
                key: 'ptoPtsFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.ptoPts',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: 'PTO' },
                        { value: '2', text: 'PTS' }
                    ]
                }
                },
                {
                key: 'procTypeFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.procType',
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                 ,options: [
                        { value: '1', text: 'E' },
                        { value: '2', text: 'F' }
                    ]
                }
                },
                {
                key: 'specialTechFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.specialTech',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'iptFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.ipt',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialGroupFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.materialGroup',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'purchaseGroupFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.purchaseGroup',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'pdtFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.pdt',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'grtFilter',
                label: 'label.sith.mst.sithMesMstKamList.filter.grt',
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                }
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'projectWbs',
                label: 'label.sith.mst.sithMesMstKamList.entity.projectWbs',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'indicateKey',
                label: 'label.sith.mst.sithMesMstKamList.entity.indicateKey',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'categoryId',
                label: 'label.sith.mst.sithMesMstKamList.entity.categoryId',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enNetwork',
                label: 'label.sith.mst.sithMesMstKamList.entity.enNetwork',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enNetworkCode',
                label: 'label.sith.mst.sithMesMstKamList.entity.enNetworkCode',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'cid',
                label: 'label.sith.mst.sithMesMstKamList.entity.cid',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enActivityId',
                label: 'label.sith.mst.sithMesMstKamList.entity.enActivityId',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enElementCode',
                label: 'label.sith.mst.sithMesMstKamList.entity.enElementCode',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enElementName',
                label: 'label.sith.mst.sithMesMstKamList.entity.enElementName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'enElementType',
                label: 'label.sith.mst.sithMesMstKamList.entity.enElementType',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'spiridonActivityId',
                label: 'label.sith.mst.sithMesMstKamList.entity.spiridonActivityId',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'spiridonActivityName',
                label: 'label.sith.mst.sithMesMstKamList.entity.spiridonActivityName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'batchUnit',
                label: 'label.sith.mst.sithMesMstKamList.entity.batchUnit',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'material',
                label: 'label.sith.mst.sithMesMstKamList.entity.material',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect',
                modalMultiSelectedType: 'string'
                    ,entity: 'sithMesMstMaterial'
                    ,correspondingField: 'material'
                        }
                },
                {
                key: 'quantity',
                label: 'label.sith.mst.sithMesMstKamList.entity.quantity',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'engineerName',
                label: 'label.sith.mst.sithMesMstKamList.entity.engineerName',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'participateAssembly',
                label: 'label.sith.mst.sithMesMstKamList.entity.participateAssembly',
                sortable: true,
                disabled: false,
                form: {
                type: 'boolean',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'scope',
                label: 'label.sith.mst.sithMesMstKamList.entity.scope',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: 'SAG' },
                        { value: '2', text: 'SITH' },
                        { value: '3', text: 'MIXED' }
                    ]
                }
                },
                {
                key: 'materialDirection',
                label: 'label.sith.mst.sithMesMstKamList.entity.materialDirection',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: 'R' },
                        { value: '2', text: '3rd' }
                    ]
                }
                },
                {
                key: 'specialNotes',
                label: 'label.sith.mst.sithMesMstKamList.entity.specialNotes',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialCn',
                label: 'label.sith.mst.sithMesMstKamList.entity.materialCn',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialType',
                label: 'label.sith.mst.sithMesMstKamList.entity.materialType',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: 'HALB' },
                        { value: '2', text: 'ROH' }
                    ]
                }
                },
                {
                key: 'ptoPts',
                label: 'label.sith.mst.sithMesMstKamList.entity.ptoPts',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: 'PTO' },
                        { value: '2', text: 'PTS' }
                    ]
                }
                },
                {
                key: 'procType',
                label: 'label.sith.mst.sithMesMstKamList.entity.procType',
                sortable: true,
                disabled: false,
                form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                    ,showLabelSelectOne: true
                ,options: [
                        { value: '1', text: 'E' },
                        { value: '2', text: 'F' }
                    ]
                }
                },
                {
                key: 'specialTech',
                label: 'label.sith.mst.sithMesMstKamList.entity.specialTech',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'ipt',
                label: 'label.sith.mst.sithMesMstKamList.entity.ipt',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'materialGroup',
                label: 'label.sith.mst.sithMesMstKamList.entity.materialGroup',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'purchaseGroup',
                label: 'label.sith.mst.sithMesMstKamList.entity.purchaseGroup',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'pdt',
                label: 'label.sith.mst.sithMesMstKamList.entity.pdt',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'grt',
                label: 'label.sith.mst.sithMesMstKamList.entity.grt',
                sortable: true,
                disabled: false,
                form: {
                type: 'input',
                modalMultiSelectedType: 'string'
                        }
                },
                {
                key: 'remark',
                label: 'label.sith.mst.sithMesMstKamList.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
                        }
                }
        ]
        
        export {SithMesMstKamList, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        